import { bffServiceInstance } from "@/plugins/api_service/services";

const prefix = "/management/facilities";
export default {
  checkAccountUsage: () =>
    bffServiceInstance.get(`${prefix}/check-account-usage`),
};
